var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"HandsontableButtonAdd"}},[_c('el-button',{staticClass:"el-button eb-button-red eb-button-small",on:{"click":_vm.addRow}},[_vm._v("添加条目")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }